import { render, staticRenderFns } from "./bundles-view.vue?vue&type=template&id=d9ba40ce&scoped=true&lang=pug"
import script from "./bundles-view.js?vue&type=script&lang=js&external"
export * from "./bundles-view.js?vue&type=script&lang=js&external"
import style0 from "./bundles-view.vue?vue&type=style&index=0&id=d9ba40ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ba40ce",
  null
  
)

export default component.exports